export default "__VITE_ASSET__B6elN9m___"